// ===========================================
// Import Hooks
// ===========================================
// React Query mutation hooks for Simply Portal CSV import

import { useMutation } from '@tanstack/react-query';
import {
  previewImport,
  executeImport,
  type ImportPreviewResponse,
  type ImportExecuteResponse,
} from '../api/import.api';

// ===========================================
// MUTATION HOOKS
// ===========================================

/**
 * Preview import from CSV files
 */
export function useImportPreview() {
  return useMutation<
    ImportPreviewResponse,
    Error,
    { classesFile: File; studentsFile: File; enrollmentsFile?: File }
  >({
    mutationFn: ({ classesFile, studentsFile, enrollmentsFile }) =>
      previewImport(classesFile, studentsFile, enrollmentsFile),
  });
}

/**
 * Execute import from CSV files
 */
export function useImportExecute() {
  return useMutation<
    ImportExecuteResponse,
    Error,
    { classesFile: File; studentsFile: File; termId: string; enrollmentsFile?: File }
  >({
    mutationFn: ({ classesFile, studentsFile, termId, enrollmentsFile }) =>
      executeImport(classesFile, studentsFile, termId, enrollmentsFile),
  });
}
